import { SHCheckbox, SHFormControlLabel } from "@components/design-systems";
import {
  CompositeValueDTO,
  InvestmentProductModelsDTO,
} from "@models/product/investment-product/entities/model";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  FeaturePath,
  FeatureProductDataPath,
  getFeaturePaths,
  getFeatureProductDataPaths,
} from "../../../utils";

interface ITableCheckboxProps {
  sectionIndex: number;
  selectedIndex: [number, number];
  featureIndex: number;
  onChange: (
    value: string,
    productDataPath: FeatureProductDataPath,
    featurePath: FeaturePath,
  ) => void;
}

export const TableFeatureCheckbox = ({
  sectionIndex,
  selectedIndex,
  featureIndex,
  onChange,
}: ITableCheckboxProps) => {
  const { setValue, getValues } = useFormContext<{
    investmentProductModels: InvestmentProductModelsDTO[];
  }>();

  const featurePath = useMemo(() => {
    return getFeaturePaths(selectedIndex, sectionIndex, featureIndex);
  }, [selectedIndex, sectionIndex, featureIndex]);

  const featureProductDataPath = useMemo(() => {
    return getFeatureProductDataPaths(
      selectedIndex,
      sectionIndex,
      featureIndex,
    );
  }, [selectedIndex, sectionIndex, featureIndex]);

  const featureProductValue = useMemo(() => {
    return getValues(featureProductDataPath.value) as string;
  }, [getValues, featureProductDataPath]);

  const [previousProductData, setPreviousProductData] = useState<string>(featureProductValue);

  const handleCheckboxChange = (isChecked: boolean) => {
    if (isChecked) {
      const productValueStr = getValues(featureProductDataPath.value) as string;
      const productDataValues = JSON.parse(
        productValueStr
      ) as CompositeValueDTO[];
      setPreviousProductData(JSON.stringify(productDataValues.reverse()));
      const updatedValue = productDataValues?.map(
        (productDataValue: CompositeValueDTO) => {
          return {
            ...productDataValue,
            value: "N/A",
          };
        },
      );
      setValue(featureProductDataPath.value, JSON.stringify(updatedValue));
    } else {
      const productDataValues = JSON.parse(previousProductData) as CompositeValueDTO[];
      const productDataValuesReverse = productDataValues.reverse();
      setPreviousProductData(JSON.stringify(productDataValuesReverse));
      setValue(
        featureProductDataPath.value,
        JSON.stringify(productDataValuesReverse),
      );
    }
    setValue(featurePath.isAdminNA, isChecked);
    onChange(
      getValues(featureProductDataPath.value) as string,
      featureProductDataPath,
      featurePath,
    );
  };

  return (
    <SHFormControlLabel
      size="small"
      control={
        <SHCheckbox
          checked={Boolean(getValues(featurePath.isAdminNA))}
          size={"small"}
          onClick={(e) => {
            handleCheckboxChange((e?.target as HTMLInputElement)?.checked);
          }}
        />
      }
      data-testid="sh-head-filter-all-button"
      label={"N/A"}
    />
  );
};
